"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailValidator = void 0;
const core_1 = require("react-hook-schema/core");
const yup_1 = require("yup");
(0, yup_1.setLocale)({
    string: {
        email: { id: "validation/email" },
    },
    // example
    // number: {
    //   min: ({ min }) => ({ key: "validation/min", values: { min } }),
    //   max: ({ max }) => ({ key: "validation/min", values: { max } }),
    // },
});
exports.emailValidator = (0, core_1.yupValidator)((0, yup_1.string)().email());
